import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import SectionColorsBoxUi from './section-colors-box-ui';
import SectionColorsBoxEditing from './section-colors-box-editing';

export default class SectionColorsBox extends Plugin {
  static get requires() {
      return [ SectionColorsBoxEditing, SectionColorsBoxUi ];
  }
}
